var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('th',{on:{"click":_vm.sortColumn}},[_vm._t("default"),_vm._v(" "),(_vm.isSortable)?[(_vm.isSorted)?_c('fa',{attrs:{"icon":_vm.sortableIcon}}):_vm._e()]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }